"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iframeResizer = require("iframe-resizer");

var _classnames = _interopRequireDefault(require("classnames"));

var _queryString = _interopRequireDefault(require("query-string"));

var _wpEmbedModule = _interopRequireDefault(require("./wp-embed.module.css"));

var WpEmbed = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(WpEmbed, _Component);

  var _super = (0, _createSuper2.default)(WpEmbed);

  function WpEmbed() {
    var _this;

    (0, _classCallCheck2.default)(this, WpEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      ready: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onIframeRef", function (ref) {
      if (!ref) return;
      _this.frameRef = ref; // setup iframe-resizer

      var config = {
        checkOrigin: false,
        log: process.env.CONFIG_ENV === 'development',
        resizedCallback: _this.onFrameResize
      };
      (0, _iframeResizer.iframeResizer)(config, ref);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFrameResize", function () {
      _this.setIframeVisible();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFrameLoad", function () {
      _this.setIframeVisible();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInfogramResize", function (e) {
      // Do some easy early returns
      if (!_this.frameRef) return;
      if (_this.frameRef.contentWindow !== e.source) return; // Try to parse data json

      var data;

      try {
        data = JSON.parse(e.data);
      } catch (error) {
        return;
      }

      if (data.context !== 'iframe.resize') {
        return;
      }

      if (!data.height) return;
      _this.frameRef.height = data.height;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIframeVisible", function () {
      if (_this.state.ready) return;

      if (_this.setVisibleTimeout) {
        clearTimeout(_this.setVisibleTimeout);
        _this.setVisibleTimeout = undefined;
      }

      _this.setState({
        ready: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(WpEmbed, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setVisibleTimeout = setTimeout(this.setIframeVisible, 3000);
      window.addEventListener('message', this.onInfogramResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onInfogramResize);
      if (this.setVisibleTimeout) clearTimeout(this.setVisibleTimeout);
      if (!this.frameRef) return;
      this.frameRef.iFrameResizer.close();
    }
  }, {
    key: "render",
    value: function render() {
      var nwaModeParam = 'nwaMode';
      var embedUrl = this.props.src;

      var parsedUrl = _queryString.default.parseUrl(embedUrl);

      var urlIncludesNwaModeParam = function urlIncludesNwaModeParam() {
        return (0, _get2.default)(parsedUrl, ['query', nwaModeParam]);
      };

      var finalEmbedUrl;

      if (embedUrl && !urlIncludesNwaModeParam()) {
        var finalQueryString = _queryString.default.stringify((0, _set2.default)(parsedUrl.query, nwaModeParam, 'embed'));

        finalEmbedUrl = "".concat(parsedUrl.url, "?").concat(finalQueryString);
      } else {
        finalEmbedUrl = embedUrl;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_wpEmbedModule.default['embed-container'], this.props.className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_wpEmbedModule.default.embed, (0, _defineProperty2.default)({}, _wpEmbedModule.default.ready, this.state.ready))
      }, /*#__PURE__*/_react.default.createElement("iframe", {
        // eslint-disable-line jsx-a11y/iframe-has-title
        scrolling: "no",
        ref: this.onIframeRef,
        src: finalEmbedUrl,
        onLoad: this.onFrameLoad,
        title: ""
      })));
    }
  }]);
  return WpEmbed;
}(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


WpEmbed.defaultProps = {
  className: ''
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

WpEmbed.propTypes = {
  /**
   * Fully qualified URI to embed source
   * eg: https://embeds.nerdwallet.com/embeds/379315.html?nwaMode=embed
   */
  src: _propTypes.default.string.isRequired,
  className: _propTypes.default.string
};
var _default = WpEmbed;
exports.default = _default;